import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6664c179"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx, _cache) {
  const _component_img_preview_btn = _resolveComponent("img-preview-btn")
  const _component_delete_btn = _resolveComponent("delete-btn")
  const _component_a_space = _resolveComponent("a-space")
  const _component_table_wrapper = _resolveComponent("table-wrapper")
  const _directive_perm = _resolveDirective("perm")

  return (_openBlock(), _createBlock(_component_table_wrapper, {
    dataSource: _ctx.fileList,
    onOnTableChange: _ctx.onTableChange,
    pagination: _ctx.pagination,
    columns: _ctx.columns,
    showCheckbox: false,
    tableHeight: _ctx.tableHeight
  }, {
    size: _withCtx(({ record }) => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.humanizeFileSize(record.size)), 1)
    ]),
    operation: _withCtx(({ record }) => [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            onClick: $event => (_ctx.downloadFile(record)),
            class: "download-class theme-color"
          }, "下载", 8, _hoisted_1),
          (_openBlock(), _createBlock(_component_img_preview_btn, {
            key: record.id,
            url: record.url
          }, null, 8, ["url"])),
          (_ctx.allowEdit)
            ? _withDirectives((_openBlock(), _createBlock(_component_delete_btn, {
                key: record.id,
                id: record.id,
                onRefresh: _ctx.refresh
              }, null, 8, ["id", "onRefresh"])), [
                [_directive_perm, _ctx.deleteAccess]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }, 8, ["dataSource", "onOnTableChange", "pagination", "columns", "tableHeight"]))
}